<template>
  <div id="app">
   <router-view></router-view>
  </div>
</template>

<script>


export default {
  name: 'app',
  
}
</script>

<style lang = 'scss'>
	
	@function count($n){
		
		@return strip-unit($n)*1vw;
		
	}
	
	@function strip-unit($number) {
	  @if type-of($number) == 'number' and not unitless($number) {
	    @return $number / ($number * 0 + 1);
	  }
	 
	  @return $number;
	}
#app {
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  
}
body{
	margin: 0px;
	
	overflow-x: hidden;
	background-color: #EFF4F9;

}
*{
	font-family:"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu;
}
.page_padding{
	padding-left: 10.68vw;
	padding-right: 10.68vw;
}
@font-face {
  font-family: 'iconfont';  /* project id 2089831 */
  src: url('//at.alicdn.com/t/font_2089831_cn4q15ptw5.eot');
  src: url('//at.alicdn.com/t/font_2089831_cn4q15ptw5.eot?#iefix') format('embedded-opentype'),
  url('//at.alicdn.com/t/font_2089831_cn4q15ptw5.woff2') format('woff2'),
  url('//at.alicdn.com/t/font_2089831_cn4q15ptw5.woff') format('woff'),
  url('//at.alicdn.com/t/font_2089831_cn4q15ptw5.ttf') format('truetype'),
  url('//at.alicdn.com/t/font_2089831_cn4q15ptw5.svg#iconfont') format('svg');
}
.iconfont{
    font-family:"iconfont" !important;
    font-size:16px;font-style:normal;
    -webkit-font-smoothing: antialiased;
    -webkit-text-stroke-width: 0.2px;
    -moz-osx-font-smoothing: grayscale;}
	
.finger{
	cursor:pointer
}
</style>
